import { render, staticRenderFns } from "./StudentProfileFornWizard.vue?vue&type=template&id=a134d764&scoped=true"
import script from "./StudentProfileFornWizard.vue?vue&type=script&lang=js"
export * from "./StudentProfileFornWizard.vue?vue&type=script&lang=js"
import style0 from "./StudentProfileFornWizard.vue?vue&type=style&index=0&id=a134d764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a134d764",
  null
  
)

export default component.exports